<script>
import {defineComponent} from "vue";
import headtip from "@/views/headTip.vue";
import consultTip from "@/components/consultTip.vue";

export default defineComponent({
  components: {consultTip, headtip},
  data(){
    return{
      dialogVisible: false,
      title: 'GPT Assistants',
      items: [
        {
          name: 'ByteDance ArkClaw',
          description: 'Deeply integrated with Feishu ecosystem, one-click low-code deployment.Rapidly implement your AI Agent and efficiently empower business collaboration!',
          url: 'https://console.volcengine.com/ark/claw ',
          image: require('@/assets/openclaw/zijie.svg'),
        },
        {
          name: 'Tencent WorkBuddy',
          description: 'Deeply integrated with WeCom and QQ, one-click connection between team communication and task workflows, fully enhancing collaboration efficiency for a smoother office experience.',
          url: 'https://www.codebuddy.cn/work',
          image: require('@/assets/openclaw/tengxun.svg'),
        },
        {
          name: 'Huawei OpenClaw',
          description: 'One-click HUAWEI CLOUD deployment, high security & compliance, a robust tech base for enterprise AI.',
          url: 'https://activity.huaweicloud.com/openclaw.html',
          image: require('@/assets/openclaw/huawei.svg'),
        },
        {
          name: 'Alibaba OpenClaw',
          description: 'AgentBay-powered enterprise hosting, cloud-native ready, elastic scaling & efficient AI operations.',
          url: 'https://www.aliyun.com/activity/ecs/clawdbot',
          image: require('@/assets/openclaw/ali.svg'),
        },
        {
          name: 'Baidu OpenClaw',
          description: 'Get started in 3–5 minutes, accessible directly via the app search box.Out-of-the-box, enabling easy development of industry AI applications.',
          url: 'https://console.bce.baidu.com/qianfan/studio/openclaw',
          image: require('@/assets/openclaw/baidu.svg'),
        },
        {
          name: 'Kimi Claw',
          description: 'Powered by Kimi LLM, superior document Q&A, one-click ecosystem integration for intelligent knowledge management and office efficiency!',
          url: 'https://www.kimi.com/bot',
          image: require('@/assets/openclaw/kimi.svg'),
        },
      ]
    }

  },
  methods:{
    tohome(){
      window.open("/")
    },
    clickConsult(item) {

      console.log(item)
      this.title = item
      this.dialogVisible = true;
      sessionStorage.setItem('title', item)
    },
    hideDialog() {
      localStorage.setItem("skip", 0)
      this.dialogVisible = false;
    },

  }
})
</script>

<template>
<div class="assistantsContainer" style="z-index: 999">
<!--  <div class="topback" ref="topback"-->
<!--       :style="{ height: '6vh', backgroundColor: scrollback ? 'rgb(245 244 246)' : 'rgb(245 244 246)' ,position:'fixed',top:'0'}">-->
<!--    <headtip :changeVisable="changeVisable" @showDialog="showPartner"></headtip>-->
<!--  </div>-->
<!--  <img @click="()=>{$parent.visible=false}" style="height:2vw;width:2vw;position:fixed;right: 2vw;top: 2vw" src="@/assets/error.png">-->
  <div class="title1">Open Claw</div>
  <!-- <div class="title2">让您一键即可访问主流人工智能工具模型</div>
  <div style="width: 100%;height: 2vw;display: flex;margin-top: 2vh">
    <div class="title2" style="display: flex;align-items: center;margin: auto">
      <img src="@/assets/kefu3.png" style="height: 2vw;width: 2vw">
      <span style="color:#f97420;">若想定制化的使用培训与开发,</span> -->
<!--      <div style="background-color: #1b1e76;color: white;padding: 0.1vh 0.5vw;border-radius: 9px;cursor: pointer;font-weight: bolder;" @click="clickConsult('Office GPTs')" >联系我们</div>-->
      <!-- <div style="background-color: #1b1e76;color: white;padding: 0.1vh 0.5vw;border-radius: 9px;cursor: pointer;font-weight: bolder;" @click="()=>{$parent.$parent.naviclickConsult('定制化AI工具')}" >联系我们</div>
    </div>
  </div> -->
  <div class="assistants" style="display: grid;grid-template-columns: minmax(0,1fr) minmax(0,1fr);padding: 0 4vw;position: relative">
    <a v-for="item in items" :key="item.name" :href="item.url" target="_blank">
      <div class="assistant" >
        <img :src="item.image">
        <div class="contentDesign">
          <div class="t1">{{ item.name }}</div>
          <div class="t2">
            {{ item.description }}
          </div>
        </div>
      </div>
    </a>
<!--    <img @click="tohome" style="height: 3vw;width: 3vw;position: absolute;top: -10vh;left: 16vw;cursor: pointer" src="@/assets/back1.png">-->
  </div>
  <consultTip
      :thisTitle="title"
      :dialogVisible="dialogVisible"
      @hideDialog="hideDialog"
  ></consultTip>
</div>
</template>

<style scoped lang="scss">
.assistantsContainer{
  width: 100%;
  background-color: rgba(237, 242, 253, 0.99);
  .topback {
    position: fixed;
    z-index: 9;
    width: 100vw;
    padding: 0 0 0 2.86077411900635vw;
  }
  .title1{
    font-size: 2vw;
    margin: auto;
    padding: 2vh 0;
    text-align: center;
    font-weight: bolder;
  }
  .title2{
    font-size: 1.1vw;
    text-align: center;

  }
  .assistant{
    margin: 2vh;
    //padding: 4vh 3vw 4vh 2vw;
    padding: 2vh 3vw 0vh 2vw;
    display: flex;
    //border: 1px solid gray;
    background-color: white;
    border-radius: 9px;
    img{
      width: 3vw;
      height: 3vw;
    }
    .contentDesign{
      margin-left: 1vw;
      .t1{
        text-align: left;
        font-size: 1.2vw;
        font-weight: bolder;
      }
      .t2{
        text-align: left;
        margin-top: 1vh;
        font-size: 0.8vw;
        height: 5.5vw;
        line-height: 1.5;
      }
    }
  }
}

</style>
